/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/brace-style */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-lonely-if */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, {
  ChangeEvent, useEffect, useRef, useState,
} from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { css } from '@emotion/css';
import {
  Menu,
  Dropdown as DropDownAnt,
  Spin,
  Input,
} from 'antd';
// import Flag from 'react-world-flags';
import {
  getCurrentTime, getPageName, isSalesforce, valueToObject,
} from 'Utils/UtilityFunctions';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectApiCalled } from 'Selector/GlobalSearchContentSelector';
import axios from '../Utils/Axios';
import { SupportedLanguage } from './models';
import { DropdownOptions } from './Options';
import { TranslationEngine } from './TranslationEngine';
import { useCookie } from './useCookie';

import CloseIcon from './CloseIcon';
import TranslateIcon from './TranslateIcon';
import SearchGlobalIcon from './SearchGlobalIcon';

const host = window.location.href;

const startTime = getCurrentTime();

const styles = {
  wrap: css`
    width: 100%;
  `,
  gadgetSelect: css`
    width: 100%;
    margin: 4px 0;
    height: 30px;
    font-family: 'Roboto';
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    &:focus-visible {
      box-shadow: none;
      outline: none;
      border: 1px solid #1ec252;
    }
  `,
  customButton: css`
    border: none;
    outline: none;
    background-color: transparent;
    padding: 0px;
    outline: none;
    box-shadow: none;
  `,
  attribution: css`
    width: 120px;
    height: 13px;
  `,
  spinner: css`
    position: fixed;
    left: 0px;
    top: 0px;
    height: 80px;
    width: 86px;
    background-color: rgba(0, 0, 0, .1);
    display: flex;
    justify-content: center;
    align-items: center;
    .ant-spin-spinning {
      height: 35px;
      background-color: #e5e5e5;
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `,
};

export const Dropdown = function (props: { options: DropdownOptions }) {
  const { options } = props;
  const dispatch = useDispatch();
  const [supportedLanguages, setSupportedLanguages] = useState<SupportedLanguage[]>([{ displayName: 'Select Language', languageCode: '' }]);
  // for UI
  const [language, setLanguage] = useState('');
  const [data, setData] = useState<any>([]);
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const htmlRef = useRef(document.querySelector('html'));
  // const [lastLanguage, setLastLanguage] = useSessionstorage('@au5ton/translate-widget/lastLanguage');
  const [lastLanguage, setLastLanguage] = useCookie('xiqtrans', 'en');
  const [icon, setToggleIcon] = useState<boolean>(true);
  const [executeTranslate, setExecuteTranslate] = useState<boolean>(false);
  const [languageIconVisible, setLanguageIconVisible] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState('');
  const apiCalled = useSelector(selectApiCalled);
  const isSalesforceFlag = isSalesforce();
  // Only run on first mount
  useEffect(() => {
    if (lastLanguage !== '') {
      setLanguage(lastLanguage);
    }
  }, []);

  useEffect(() => {
    if (apiCalled) {
      const timer = setTimeout(() => {
        setLanguageIconVisible(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [apiCalled]);

  useEffect(() => {
    const getSupporttedLanguages = async () => {
      setIsLoading(true);
      await axios.get(options.endpoints.supportedLanguages)
        .then((res) => {
          setData(res);
          setIsLoading(false);
        }).catch((err) => {
          setIsLoading(false);
        });
    };
    getSupporttedLanguages();
  }, []);

  /**
   * update <select> once the languages load for the first time
   */
  useEffect(() => {
    // this condition should only happen on the first load
    if (data !== undefined && supportedLanguages.length === 1) {
      // if we only want a handful of languages to show instead of the entire list
      if (options.preferredSupportedLanguages.length > 1) {
        setSupportedLanguages((x) => [
          ...x,
          ...data
            .filter(({ languageCode }: { languageCode: string }) => options.preferredSupportedLanguages.includes(languageCode)),
        ]);
      } else {
        setSupportedLanguages((x) => [
          ...x,
          ...data,
        ]);
      }
    }
  }, [data]);

  /**
   * Respond to changes in language
   */
  useEffect(() => {
    if (options.verboseOutput) console.log('language changed');
    if (language !== '' && options.pageLanguage !== language) {
      setShowBanner(true);
      if (options.updateDocumentLanguageAttribute) htmlRef.current?.setAttribute('lang', `${language}-x-mtfrom-${options.pageLanguage}`);
    } else if (options.updateDocumentLanguageAttribute) htmlRef.current?.setAttribute('lang', options.pageLanguage);
    setLastLanguage(language);
  }, [language]);

  // whenever a new language option is selected
  const handleChange = (languageCode: string) => {
    setLanguage(languageCode);

    setExecuteTranslate(true);

    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`confirmed_LanguageChange_${languageCode}_${getPageName()}`, startTime, {
        host,
      }),
    ));

    setSupportedLanguages((x) => {
      // check if placeholder exists
      const placeholderIndex = x.findIndex((e) => e.languageCode === '');
      if (placeholderIndex >= 0) {
        // remove if it exists
        x.splice(placeholderIndex, 1);
      }

      // move the native language to the top of the list
      x.unshift(x.splice(x.findIndex((e) => e.languageCode === options.pageLanguage), 1)[0]);
      return x;
    });

    setTimeout(() => {
      location.reload();
    }, 700);
  };

  const changeBehaviour = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`intent_LanguageChange_${getPageName()}`, startTime, {
        host,
      }),
    ));

    setToggleIcon(!icon);
    setSearchTerm('');
  };

  const isTranslationActive = language !== '' && language !== options.pageLanguage;

  const filteredLanguages = supportedLanguages.filter((supportedLanguage) => supportedLanguage.displayName?.toLowerCase()?.includes(searchTerm.toLowerCase()));
  const languageMenu = (
    <div className="dropdown-placeholer">
      <h6 className="language-heading">Select Language</h6>
      <Input
        prefix={<SearchGlobalIcon />}
        className="widget-search-bar"
        placeholder="Search languages"
        value={searchTerm}
        onClick={(e) => e.stopPropagation()}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          e.stopPropagation();
          setSearchTerm(e.target.value);
        }}
      />
      <Menu className={styles.gadgetSelect} aria-label="Language Translate Widget" rootClassName="skpitranslate">
        {filteredLanguages.length ? filteredLanguages.map((e) => {
          const isSelected = e.languageCode === language;
          return (
            <Menu.Item
              key={e.languageCode}
              onClick={() => handleChange(e.languageCode)}
              className={classNames(`skiptranslate ${e.displayName}`, { selectedValue: isSelected })}
            >
              {/* <Flag
                code={e.languageCode}
                className="dropDown-flag"
                fallback={<img src="https://media.xiqonline.com/salesApp/images/defaultLanguageFlag.png" alt="defaultIcon" className="placeholder-flag inner" />}
              /> */}
              {e.displayName}
            </Menu.Item>
          );
        }) : (
          <div className="empty-message">No langauge found</div>
        )}
      </Menu>
    </div>

  );

  return (
    <>
      {isTranslationActive && (
        <TranslationEngine
          options={options}
          language={language}
          executeTranslate={executeTranslate}
          setIsLoading={setIsLoading}
        />
      )}
      {(languageIconVisible && !isSalesforceFlag) && (
        <div className={`${styles.wrap} skiptranslate languageTranslationGlobal`}>
          <DropDownAnt getPopupContainer={(e) => e} overlay={languageMenu} trigger={['click']} placement="bottomRight" className="skpitranslate" onVisibleChange={changeBehaviour}>
            <button className={`${styles.customButton}`}>
              {' '}
              {/* <Flag
            code={language}
            className="flagPlaceholder"
            fallback={<img src="https://media.xiqonline.com/salesApp/images/defaultLanguageFlag.png" alt="defaultIcon" className="placeholder-flag" />}
          /> */}
              <button className={`${styles.customButton} button-wrapper-t`}>
                {icon ? <TranslateIcon /> : <CloseIcon />}
              </button>
            </button>
          </DropDownAnt>
          {isLoading ? createPortal(<span className={`${styles.spinner}`}><Spin /></span>, document.body) : null}
          {options.attributionImageUrl ? <img className={styles.attribution} src={options.attributionImageUrl} /> : null}
        </div>
      )}
    </>
  );
};
